import React from "react";
import { useParams } from "react-router-dom";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewClubPageNew from "../../components/Club/ViewClubPageNew";

const ViewUserClubPage = () => {
  // ✅ grab both id and userid from route
  const { id, userid } = useParams();

  return (
    <MasterLayout>
      {/* Breadcrumb */}
      <Breadcrumb
        id="title"
        title2="Host Management"
        link2="/host"
        title3="Host Detail"
        link3={`/host/view-host/${userid}`} // ✅ link3 should include userid
        title="View Club"
      />

      {/* Pass props down */}
      <ViewClubPageNew roles="user" clubId={id} userId={userid} />
    </MasterLayout>
  );
};

export default ViewUserClubPage;
